<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="ibox login-content">
  <div class="text-center">
    <span class="auth-head-icon"><em class="la la-key"></em></span>
  </div>

  <div class="ibox-head justify-content-center">
    <div class="ibox-title text-uppercase text-center" i18n="@@forgotPassword">Forgot password</div>
  </div>

  <div class="ibox-body">
    <form [formGroup]="forgotPasswordFG" #forgotPasswordForm="ngForm" (ngSubmit)="resetPasswordFormSubmit()">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-justify mb-2">
        <p i18n="@@forgotPasswordInfo">
          Enter your email address below and we'll send you password reset instructions.
        </p>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
        <app-input-email controlName="email" [formGroup]="forgotPasswordFG"
                         [submitted]="forgotPasswordForm?.submitted"></app-input-email>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <button type="submit" class="btn btn-success btn-rounded btn-block text-uppercase" i18n="@@sendRequest">
          Send request
        </button>
      </div>
    </form>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-4">
      <app-display-go-home></app-display-go-home>
    </div>
  </div>
</div>
